import { render, staticRenderFns } from "./TextWithHighlight.vue?vue&type=template&id=42aba73d&"
import script from "./TextWithHighlight.vue?vue&type=script&lang=js&"
export * from "./TextWithHighlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports